/* eslint-disable */
import * as Types from '../types.generated';

import {
    PlatformFieldsFragment,
    OwnershipFieldsFragment,
    GlobalTagsFieldsFragment,
    GlossaryTermsFragment,
    EntityDomainFragment,
    EntityDataProduct_AccessTokenMetadata_Fragment,
    EntityDataProduct_Assertion_Fragment,
    EntityDataProduct_Chart_Fragment,
    EntityDataProduct_Container_Fragment,
    EntityDataProduct_CorpGroup_Fragment,
    EntityDataProduct_CorpUser_Fragment,
    EntityDataProduct_Dashboard_Fragment,
    EntityDataProduct_DataFlow_Fragment,
    EntityDataProduct_DataHubPolicy_Fragment,
    EntityDataProduct_DataHubRole_Fragment,
    EntityDataProduct_DataHubView_Fragment,
    EntityDataProduct_DataJob_Fragment,
    EntityDataProduct_DataPlatform_Fragment,
    EntityDataProduct_DataPlatformInstance_Fragment,
    EntityDataProduct_DataProcessInstance_Fragment,
    EntityDataProduct_DataProduct_Fragment,
    EntityDataProduct_DataTypeEntity_Fragment,
    EntityDataProduct_Dataset_Fragment,
    EntityDataProduct_Domain_Fragment,
    EntityDataProduct_EntityTypeEntity_Fragment,
    EntityDataProduct_GlossaryNode_Fragment,
    EntityDataProduct_GlossaryTerm_Fragment,
    EntityDataProduct_MlFeature_Fragment,
    EntityDataProduct_MlFeatureTable_Fragment,
    EntityDataProduct_MlModel_Fragment,
    EntityDataProduct_MlModelGroup_Fragment,
    EntityDataProduct_MlPrimaryKey_Fragment,
    EntityDataProduct_Notebook_Fragment,
    EntityDataProduct_OwnershipTypeEntity_Fragment,
    EntityDataProduct_Post_Fragment,
    EntityDataProduct_QueryEntity_Fragment,
    EntityDataProduct_Role_Fragment,
    EntityDataProduct_SchemaFieldEntity_Fragment,
    EntityDataProduct_StructuredPropertyEntity_Fragment,
    EntityDataProduct_Tag_Fragment,
    EntityDataProduct_Test_Fragment,
    EntityDataProduct_VersionedDataset_Fragment,
    NonRecursiveDataFlowFieldsFragment,
    InstitutionalMemoryFieldsFragment,
    DeprecationFieldsFragment,
    EmbedFieldsFragment,
    DataPlatformInstanceFieldsFragment,
    ParentContainersFieldsFragment,
    BrowsePathV2FieldsFragment,
    InputFieldsFieldsFragment,
    EntityContainerFragment,
    StructuredPropertiesFieldsFragment,
    TypeOfRelationsFieldsFragment,
    ParentNodesFieldsFragment,
    ReadOnlyFieldsFragment,
    GlossaryNodeFragment,
    GlossaryTermFragment,
    ParentDomainsFieldsFragment,
    DomainEntitiesFieldsFragment,
    NonRecursiveMlFeatureTableFragment,
    NonRecursiveMlFeatureFragment,
    NonRecursiveMlPrimaryKeyFragment,
    SchemaMetadataFieldsFragment,
    NonConflictingPlatformFieldsFragment,
    EntityDisplayNameFields_AccessTokenMetadata_Fragment,
    EntityDisplayNameFields_Assertion_Fragment,
    EntityDisplayNameFields_Chart_Fragment,
    EntityDisplayNameFields_Container_Fragment,
    EntityDisplayNameFields_CorpGroup_Fragment,
    EntityDisplayNameFields_CorpUser_Fragment,
    EntityDisplayNameFields_Dashboard_Fragment,
    EntityDisplayNameFields_DataFlow_Fragment,
    EntityDisplayNameFields_DataHubPolicy_Fragment,
    EntityDisplayNameFields_DataHubRole_Fragment,
    EntityDisplayNameFields_DataHubView_Fragment,
    EntityDisplayNameFields_DataJob_Fragment,
    EntityDisplayNameFields_DataPlatform_Fragment,
    EntityDisplayNameFields_DataPlatformInstance_Fragment,
    EntityDisplayNameFields_DataProcessInstance_Fragment,
    EntityDisplayNameFields_DataProduct_Fragment,
    EntityDisplayNameFields_DataTypeEntity_Fragment,
    EntityDisplayNameFields_Dataset_Fragment,
    EntityDisplayNameFields_Domain_Fragment,
    EntityDisplayNameFields_EntityTypeEntity_Fragment,
    EntityDisplayNameFields_GlossaryNode_Fragment,
    EntityDisplayNameFields_GlossaryTerm_Fragment,
    EntityDisplayNameFields_MlFeature_Fragment,
    EntityDisplayNameFields_MlFeatureTable_Fragment,
    EntityDisplayNameFields_MlModel_Fragment,
    EntityDisplayNameFields_MlModelGroup_Fragment,
    EntityDisplayNameFields_MlPrimaryKey_Fragment,
    EntityDisplayNameFields_Notebook_Fragment,
    EntityDisplayNameFields_OwnershipTypeEntity_Fragment,
    EntityDisplayNameFields_Post_Fragment,
    EntityDisplayNameFields_QueryEntity_Fragment,
    EntityDisplayNameFields_Role_Fragment,
    EntityDisplayNameFields_SchemaFieldEntity_Fragment,
    EntityDisplayNameFields_StructuredPropertyEntity_Fragment,
    EntityDisplayNameFields_Tag_Fragment,
    EntityDisplayNameFields_Test_Fragment,
    EntityDisplayNameFields_VersionedDataset_Fragment,
} from './fragments.generated';
import { PartialLineageResultsFragment } from './lineage.generated';
import { gql } from '@apollo/client';
import {
    PlatformFieldsFragmentDoc,
    OwnershipFieldsFragmentDoc,
    GlobalTagsFieldsFragmentDoc,
    GlossaryTermsFragmentDoc,
    EntityDomainFragmentDoc,
    EntityDataProductFragmentDoc,
    NonRecursiveDataFlowFieldsFragmentDoc,
    InstitutionalMemoryFieldsFragmentDoc,
    DeprecationFieldsFragmentDoc,
    EmbedFieldsFragmentDoc,
    DataPlatformInstanceFieldsFragmentDoc,
    ParentContainersFieldsFragmentDoc,
    BrowsePathV2FieldsFragmentDoc,
    InputFieldsFieldsFragmentDoc,
    EntityContainerFragmentDoc,
    StructuredPropertiesFieldsFragmentDoc,
    TypeOfRelationsFieldsFragmentDoc,
    ParentNodesFieldsFragmentDoc,
    ReadOnlyFieldsFragmentDoc,
    GlossaryNodeFragmentDoc,
    GlossaryTermFragmentDoc,
    ParentDomainsFieldsFragmentDoc,
    DomainEntitiesFieldsFragmentDoc,
    NonRecursiveMlFeatureTableFragmentDoc,
    NonRecursiveMlFeatureFragmentDoc,
    NonRecursiveMlPrimaryKeyFragmentDoc,
    SchemaMetadataFieldsFragmentDoc,
    NonConflictingPlatformFieldsFragmentDoc,
    EntityDisplayNameFieldsFragmentDoc,
} from './fragments.generated';
import { PartialLineageResultsFragmentDoc } from './lineage.generated';
import * as Apollo from '@apollo/client';
export type DataFlowFieldsFragment = { __typename?: 'DataFlow' } & Pick<
    Types.DataFlow,
    'urn' | 'type' | 'exists' | 'lastIngested' | 'orchestrator' | 'flowId' | 'cluster'
> & {
        platform: { __typename?: 'DataPlatform' } & PlatformFieldsFragment;
        properties?: Types.Maybe<
            { __typename?: 'DataFlowProperties' } & Pick<
                Types.DataFlowProperties,
                'name' | 'description' | 'project' | 'externalUrl'
            > & {
                    customProperties?: Types.Maybe<
                        Array<
                            { __typename?: 'CustomPropertiesEntry' } & Pick<
                                Types.CustomPropertiesEntry,
                                'key' | 'value' | 'isEditable'
                            >
                        >
                    >;
                }
        >;
        editableProperties?: Types.Maybe<
            { __typename?: 'DataFlowEditableProperties' } & Pick<Types.DataFlowEditableProperties, 'description'>
        >;
        ownership?: Types.Maybe<{ __typename?: 'Ownership' } & OwnershipFieldsFragment>;
        globalTags?: Types.Maybe<{ __typename?: 'GlobalTags' } & GlobalTagsFieldsFragment>;
        institutionalMemory?: Types.Maybe<{ __typename?: 'InstitutionalMemory' } & InstitutionalMemoryFieldsFragment>;
        glossaryTerms?: Types.Maybe<{ __typename?: 'GlossaryTerms' } & GlossaryTermsFragment>;
        domain?: Types.Maybe<{ __typename?: 'DomainAssociation' } & EntityDomainFragment>;
        status?: Types.Maybe<{ __typename?: 'Status' } & Pick<Types.Status, 'removed'>>;
        deprecation?: Types.Maybe<{ __typename?: 'Deprecation' } & DeprecationFieldsFragment>;
        dataPlatformInstance?: Types.Maybe<
            { __typename?: 'DataPlatformInstance' } & DataPlatformInstanceFieldsFragment
        >;
        browsePathV2?: Types.Maybe<{ __typename?: 'BrowsePathV2' } & BrowsePathV2FieldsFragment>;
    } & EntityDataProduct_DataFlow_Fragment;

export type GetDataFlowQueryVariables = Types.Exact<{
    urn: Types.Scalars['String'];
}>;

export type GetDataFlowQuery = { __typename?: 'Query' } & {
    dataFlow?: Types.Maybe<
        { __typename?: 'DataFlow' } & {
            upstream?: Types.Maybe<{ __typename?: 'EntityLineageResult' } & PartialLineageResultsFragment>;
            downstream?: Types.Maybe<{ __typename?: 'EntityLineageResult' } & PartialLineageResultsFragment>;
            childJobs?: Types.Maybe<
                { __typename?: 'EntityRelationshipsResult' } & Pick<
                    Types.EntityRelationshipsResult,
                    'start' | 'count' | 'total'
                > & {
                        relationships: Array<
                            { __typename?: 'EntityRelationship' } & {
                                entity?: Types.Maybe<
                                    | { __typename?: 'AccessTokenMetadata' }
                                    | { __typename?: 'Assertion' }
                                    | { __typename?: 'Chart' }
                                    | { __typename?: 'Container' }
                                    | { __typename?: 'CorpGroup' }
                                    | { __typename?: 'CorpUser' }
                                    | { __typename?: 'Dashboard' }
                                    | { __typename?: 'DataFlow' }
                                    | { __typename?: 'DataHubPolicy' }
                                    | { __typename?: 'DataHubRole' }
                                    | { __typename?: 'DataHubView' }
                                    | ({ __typename?: 'DataJob' } & Pick<Types.DataJob, 'urn' | 'type' | 'jobId'> & {
                                              dataFlow?: Types.Maybe<
                                                  { __typename?: 'DataFlow' } & Pick<
                                                      Types.DataFlow,
                                                      'urn' | 'type' | 'orchestrator'
                                                  > & {
                                                          platform: {
                                                              __typename?: 'DataPlatform';
                                                          } & PlatformFieldsFragment;
                                                      }
                                              >;
                                              ownership?: Types.Maybe<
                                                  { __typename?: 'Ownership' } & OwnershipFieldsFragment
                                              >;
                                              properties?: Types.Maybe<
                                                  { __typename?: 'DataJobProperties' } & Pick<
                                                      Types.DataJobProperties,
                                                      'name' | 'description'
                                                  >
                                              >;
                                              editableProperties?: Types.Maybe<
                                                  { __typename?: 'DataJobEditableProperties' } & Pick<
                                                      Types.DataJobEditableProperties,
                                                      'description'
                                                  >
                                              >;
                                              globalTags?: Types.Maybe<
                                                  { __typename?: 'GlobalTags' } & GlobalTagsFieldsFragment
                                              >;
                                              glossaryTerms?: Types.Maybe<
                                                  { __typename?: 'GlossaryTerms' } & GlossaryTermsFragment
                                              >;
                                              deprecation?: Types.Maybe<
                                                  { __typename?: 'Deprecation' } & DeprecationFieldsFragment
                                              >;
                                          })
                                    | { __typename?: 'DataPlatform' }
                                    | { __typename?: 'DataPlatformInstance' }
                                    | { __typename?: 'DataProcessInstance' }
                                    | { __typename?: 'DataProduct' }
                                    | { __typename?: 'DataTypeEntity' }
                                    | { __typename?: 'Dataset' }
                                    | { __typename?: 'Domain' }
                                    | { __typename?: 'EntityTypeEntity' }
                                    | { __typename?: 'GlossaryNode' }
                                    | { __typename?: 'GlossaryTerm' }
                                    | { __typename?: 'MLFeature' }
                                    | { __typename?: 'MLFeatureTable' }
                                    | { __typename?: 'MLModel' }
                                    | { __typename?: 'MLModelGroup' }
                                    | { __typename?: 'MLPrimaryKey' }
                                    | { __typename?: 'Notebook' }
                                    | { __typename?: 'OwnershipTypeEntity' }
                                    | { __typename?: 'Post' }
                                    | { __typename?: 'QueryEntity' }
                                    | { __typename?: 'Role' }
                                    | { __typename?: 'SchemaFieldEntity' }
                                    | { __typename?: 'StructuredPropertyEntity' }
                                    | { __typename?: 'Tag' }
                                    | { __typename?: 'Test' }
                                    | { __typename?: 'VersionedDataset' }
                                >;
                            }
                        >;
                    }
            >;
            structuredProperties?: Types.Maybe<
                { __typename?: 'StructuredProperties' } & {
                    properties?: Types.Maybe<
                        Array<{ __typename?: 'StructuredPropertiesEntry' } & StructuredPropertiesFieldsFragment>
                    >;
                }
            >;
        } & DataFlowFieldsFragment
    >;
};

export type UpdateDataFlowMutationVariables = Types.Exact<{
    urn: Types.Scalars['String'];
    input: Types.DataFlowUpdateInput;
}>;

export type UpdateDataFlowMutation = { __typename?: 'Mutation' } & {
    updateDataFlow?: Types.Maybe<{ __typename?: 'DataFlow' } & Pick<Types.DataFlow, 'urn'>>;
};

export const DataFlowFieldsFragmentDoc = gql`
    fragment dataFlowFields on DataFlow {
        urn
        type
        exists
        lastIngested
        orchestrator
        flowId
        cluster
        platform {
            ...platformFields
        }
        properties {
            name
            description
            project
            externalUrl
            customProperties {
                key
                value
                isEditable
            }
        }
        editableProperties {
            description
        }
        ownership {
            ...ownershipFields
        }
        globalTags {
            ...globalTagsFields
        }
        institutionalMemory {
            ...institutionalMemoryFields
        }
        glossaryTerms {
            ...glossaryTerms
        }
        domain {
            ...entityDomain
        }
        ...entityDataProduct
        status {
            removed
        }
        deprecation {
            ...deprecationFields
        }
        dataPlatformInstance {
            ...dataPlatformInstanceFields
        }
        browsePathV2 {
            ...browsePathV2Fields
        }
    }
    ${PlatformFieldsFragmentDoc}
    ${OwnershipFieldsFragmentDoc}
    ${GlobalTagsFieldsFragmentDoc}
    ${InstitutionalMemoryFieldsFragmentDoc}
    ${GlossaryTermsFragmentDoc}
    ${EntityDomainFragmentDoc}
    ${EntityDataProductFragmentDoc}
    ${DeprecationFieldsFragmentDoc}
    ${DataPlatformInstanceFieldsFragmentDoc}
    ${BrowsePathV2FieldsFragmentDoc}
`;
export const GetDataFlowDocument = gql`
    query getDataFlow($urn: String!) {
        dataFlow(urn: $urn) {
            ...dataFlowFields
            upstream: lineage(input: { direction: UPSTREAM, start: 0, count: 100 }) {
                ...partialLineageResults
            }
            downstream: lineage(input: { direction: DOWNSTREAM, start: 0, count: 100 }) {
                ...partialLineageResults
            }
            childJobs: relationships(input: { types: ["IsPartOf"], direction: INCOMING, start: 0, count: 100 }) {
                start
                count
                total
                relationships {
                    entity {
                        ... on DataJob {
                            urn
                            type
                            jobId
                            dataFlow {
                                urn
                                type
                                orchestrator
                                platform {
                                    ...platformFields
                                }
                            }
                            ownership {
                                ...ownershipFields
                            }
                            properties {
                                name
                                description
                            }
                            editableProperties {
                                description
                            }
                            globalTags {
                                ...globalTagsFields
                            }
                            glossaryTerms {
                                ...glossaryTerms
                            }
                            deprecation {
                                ...deprecationFields
                            }
                        }
                    }
                }
            }
            structuredProperties {
                properties {
                    ...structuredPropertiesFields
                }
            }
        }
    }
    ${DataFlowFieldsFragmentDoc}
    ${PartialLineageResultsFragmentDoc}
    ${PlatformFieldsFragmentDoc}
    ${OwnershipFieldsFragmentDoc}
    ${GlobalTagsFieldsFragmentDoc}
    ${GlossaryTermsFragmentDoc}
    ${DeprecationFieldsFragmentDoc}
    ${StructuredPropertiesFieldsFragmentDoc}
`;

/**
 * __useGetDataFlowQuery__
 *
 * To run a query within a React component, call `useGetDataFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataFlowQuery({
 *   variables: {
 *      urn: // value for 'urn'
 *   },
 * });
 */
export function useGetDataFlowQuery(baseOptions: Apollo.QueryHookOptions<GetDataFlowQuery, GetDataFlowQueryVariables>) {
    return Apollo.useQuery<GetDataFlowQuery, GetDataFlowQueryVariables>(GetDataFlowDocument, baseOptions);
}
export function useGetDataFlowLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetDataFlowQuery, GetDataFlowQueryVariables>,
) {
    return Apollo.useLazyQuery<GetDataFlowQuery, GetDataFlowQueryVariables>(GetDataFlowDocument, baseOptions);
}
export type GetDataFlowQueryHookResult = ReturnType<typeof useGetDataFlowQuery>;
export type GetDataFlowLazyQueryHookResult = ReturnType<typeof useGetDataFlowLazyQuery>;
export type GetDataFlowQueryResult = Apollo.QueryResult<GetDataFlowQuery, GetDataFlowQueryVariables>;
export const UpdateDataFlowDocument = gql`
    mutation updateDataFlow($urn: String!, $input: DataFlowUpdateInput!) {
        updateDataFlow(urn: $urn, input: $input) {
            urn
        }
    }
`;
export type UpdateDataFlowMutationFn = Apollo.MutationFunction<UpdateDataFlowMutation, UpdateDataFlowMutationVariables>;

/**
 * __useUpdateDataFlowMutation__
 *
 * To run a mutation, you first call `useUpdateDataFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDataFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDataFlowMutation, { data, loading, error }] = useUpdateDataFlowMutation({
 *   variables: {
 *      urn: // value for 'urn'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDataFlowMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateDataFlowMutation, UpdateDataFlowMutationVariables>,
) {
    return Apollo.useMutation<UpdateDataFlowMutation, UpdateDataFlowMutationVariables>(
        UpdateDataFlowDocument,
        baseOptions,
    );
}
export type UpdateDataFlowMutationHookResult = ReturnType<typeof useUpdateDataFlowMutation>;
export type UpdateDataFlowMutationResult = Apollo.MutationResult<UpdateDataFlowMutation>;
export type UpdateDataFlowMutationOptions = Apollo.BaseMutationOptions<
    UpdateDataFlowMutation,
    UpdateDataFlowMutationVariables
>;
